import './RadioInput.scss'

const RadioInput = ({ labelColor, label, handleChange, name, ...props }: any) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value
    handleChange({ value, name })
  }

  return (
    <div className={`radio-input`}>
      <label className={`radio-input__label`}>
        <input onChange={onChange} className={`radio-input__input`} type='radio' {...props} />
        <div className='checkmark' style={{ background: props.checked && labelColor }} />
        {label || ''}
      </label>
    </div>
  )
}

export default RadioInput
